const InfoNotification = ({ message }) => {
    return (
        <div className="notification-info">
            <span>Info: {message}</span>
        </div>
    );
};

export default InfoNotification;
